---
title: 'Singulate Analytics'
description: "Personalization analytics that reveal engagement by segment and compare personalized against fallback content, so you can optimize campaigns."
route: '/support/product/singulate-analytics'
category: 'product'
---
Singulate comes with powerful personalization analytics that reveal audience engagement within your segments, fallback vs. personalized content metrics, and more so you can identify engaged audiences, minimize noise, and optimize your campaigns.

### Where to find your analytics:

****

****Head to Campaigns > Completed or Automations > Completed and click the burger menu (3 dots) on the far right side of the campaign you wish to see the analytics for. 

![](</media/69fce6a479453c1fcf3011de_where to find the analytics tab.png>)

First, you’ll see an overview of email performance: total contacts, emails delivered, opens, clicks, and unsubscribes:

![](</media/69fce6d1c6badcfe1466a3e1_analytics summary.png>)

You’ll also see personalization analytics for Singulate Snippets:

![Singulated Snippets analytics reveal how many contacts received personalized vs. fallback text and the open, CTR, and click-to-open rates of each.](</media/69fce6e8652c2de95228d20c_snippet analytics panel.png>)

_Singulated Snippets analytics reveal how many contacts received personalized vs. fallback text and the open, CTR, and click-to-open rates of each._

...And for Branched content: 

![Branched content analytics reveal how many contacts fell into your segments, as well as opens, CTRs, and clicks-to-open metrics by segment.](</media/69fce70eb532f304688196d7_branched content analytics panel.png>)

_Branched content analytics reveal how many contacts fell into your segments, as well as opens, CTRs, and clicks-to-open metrics by segment._
